/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Windows_ReqInputs */

const en_fc_dl_windows_req = /** @type {(inputs: Fc_Dl_Windows_ReqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows · Most Windows 10 and 11 PCs (x64, ARM64 or 32-bit x86)`)
};

/**
* | output |
* | --- |
* | "Windows · Most Windows 10 and 11 PCs (x64, ARM64 or 32-bit x86)" |
*
* @param {Fc_Dl_Windows_ReqInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_windows_req = /** @type {((inputs?: Fc_Dl_Windows_ReqInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Windows_ReqInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_windows_req(inputs)
});
export { fc_dl_windows_req as "fc.dl.windows.req" }